<div class="bl-wrapper" [ngClass]="{ 'hide-border-bottom': showCloseButton }">
  <h4 class="title">Share property with your buyers lists:</h4>

  <app-shared-loading
    *ngIf="loadingBuyersList"
    text="Loading buyers list..."
    position="left"
  ></app-shared-loading>

  <div *ngIf="!userHasOrganization">
    No buyers list.
    <a routerLink="/my-organization" class="text-primary-500">Click here</a> to
    complete your organization setup.
  </div>

  <ng-container *ngIf="userHasOrganization && !loadingBuyersList">
    <div *ngIf="error">Unable to load buyers list. Please try again later.</div>

    <ng-container *ngIf="!error">
      <div *ngIf="all_buy_lists_one_day_limit">
        The free tier only allows you to share a buyers list once a day. Please
        upgrade to a paid tier to share a buyers list more than once a day.
      </div>

      <ng-container *ngIf="!all_buy_lists_one_day_limit">
        <div *ngIf="success" class="success">
          <ng-icon name="featherCheckCircle"></ng-icon>
          <span class="ml-1">
            Property shared successfully with the selected buyers list.
          </span>
        </div>

        <ng-container *ngIf="!success">
          <div class="items">
            <ng-container>
              <div
                *ngFor="let item of buyersList; trackBy: trackByFn"
                class="item"
              >
                <mat-checkbox
                  class="custom-checkbox"
                  color="primary"
                  [disabled]="
                    sending || item.allowShareParsed?.['allow_share?'] === false
                  "
                  [checked]="selected.has(item.id)"
                  (change)="toggleSelection(item.id, $event.checked)"
                >
                  {{ item.name }}
                  <sup *ngIf="item.allowShareParsed?.['allow_share?'] === false"
                    >Share available in {{ item.remainingTimeFormatted }}</sup
                  >
                </mat-checkbox>
              </div>
              <div *ngIf="!buyersList.length" class="no-data">
                No buyers list found. You can create one
                <a routerLink="/upload-buyers">here</a>.
              </div>
            </ng-container>

            <div class="item">
              <mat-checkbox
                class="custom-checkbox"
                color="primary"
                [disabled]="sending"
                [checked]="multipleTypes"
                (change)="multipleTypes = $event.checked"
              >
                <span class="font-medium">
                  Also send an {{ type === 'EMAIL' ? 'SMS' : 'email' }} blast to
                  these lists
                </span>
              </mat-checkbox>
            </div>
          </div>

          <div *ngIf="buyersList.length" class="flex mt-2">
            <app-shared-button
              (click)="shareWithList()"
              [loading]="sending"
              [disabled]="selected.size === 0 || sending"
              [tp]="
                selected.size === 0
                  ? 'Select at least one buyers list.'
                  : undefined
              "
            >
              Share with list
            </app-shared-button>
            <app-shared-button
              *ngIf="showCloseButton"
              (click)="handleClose.emit()"
              class="ml-2"
              theme="outline"
            >
              Cancel
            </app-shared-button>
          </div>

          <div *ngIf="selected.size === 0" class="font-medium mt-2">
            <div class="input-error-message">
              Select at least one buyers list to share this property.
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
